import {
  format,
  subMonths,
  subDays,
  startOfDay,
  endOfDay,
  startOfMonth,
  endOfMonth,
  differenceInCalendarDays,
  parseISO,
} from 'date-fns'

export type PeriodPreset =
  | 'yesterday'
  | 'today'
  | '7d'
  | '30d'
  | 'currentMonth'
  | 'lastMonth'
  | 'custom'

export type PeriodGranularity = 'day' | 'month'

export const PERIOD_PRESET_LABELS: Record<PeriodPreset, string> = {
  yesterday: 'Ontem',
  today: 'Hoje',
  '7d': '7 dias',
  '30d': '30 dias',
  currentMonth: 'Mês atual',
  lastMonth: 'Mês anterior',
  custom: 'Personalizado',
}

export function getPeriodRange(
  preset: PeriodPreset,
  customStart: string,
  customEnd: string,
): { startDate: string; endDate: string } {
  const now = new Date()
  if (preset === 'custom' && customStart && customEnd) {
    return { startDate: customStart, endDate: customEnd }
  }
  if (preset === 'yesterday') {
    const d = subDays(now, 1)
    return {
      startDate: format(startOfDay(d), 'yyyy-MM-dd'),
      endDate: format(endOfDay(d), 'yyyy-MM-dd'),
    }
  }
  if (preset === 'today') {
    return {
      startDate: format(startOfDay(now), 'yyyy-MM-dd'),
      endDate: format(endOfDay(now), 'yyyy-MM-dd'),
    }
  }
  if (preset === '7d') {
    return {
      startDate: format(startOfDay(subDays(now, 6)), 'yyyy-MM-dd'),
      endDate: format(endOfDay(now), 'yyyy-MM-dd'),
    }
  }
  if (preset === '30d') {
    return {
      startDate: format(startOfDay(subDays(now, 29)), 'yyyy-MM-dd'),
      endDate: format(endOfDay(now), 'yyyy-MM-dd'),
    }
  }
  if (preset === 'lastMonth') {
    const ref = subMonths(now, 1)
    return {
      startDate: format(startOfMonth(ref), 'yyyy-MM-dd'),
      endDate: format(endOfMonth(ref), 'yyyy-MM-dd'),
    }
  }
  // currentMonth (default)
  return {
    startDate: format(startOfMonth(now), 'yyyy-MM-dd'),
    endDate: format(endOfDay(now), 'yyyy-MM-dd'),
  }
}

/**
 * Decide a granularidade do gráfico do período conforme a duração.
 * <= 92 dias → "day" (eixo X mostra dias). Acima disso → "month".
 */
export function getPeriodGranularity(
  startDate: string,
  endDate: string,
): PeriodGranularity {
  if (!startDate || !endDate) return 'day'
  try {
    const diff = differenceInCalendarDays(parseISO(endDate), parseISO(startDate))
    return diff <= 92 ? 'day' : 'month'
  } catch {
    return 'day'
  }
}
